import * as v from "valibot";
import { rpcContract } from "../rpc";

export const adminFansRpcContract = rpcContract({
  name: "adminFans",
  paramsSchema: v.object({
    limit: v.pipe(v.optional(v.number(), 25), v.minValue(1), v.maxValue(50)),
    offset: v.pipe(v.optional(v.number(), 0), v.minValue(0)),
    search: v.optional(v.string()),
    isActive: v.optional(v.picklist(["yes", "no"])),
    isStaff: v.optional(v.picklist(["yes", "no"])),
    sortBy: v.optional(v.picklist(["email", "dateJoined"])),
    sortOrder: v.optional(v.picklist(["asc", "desc"])),
  }),
  resultSchema: v.object({
    fans: v.array(
      v.object({
        id: v.string(),
        email: v.string(),
        isActive: v.boolean(),
        isStaff: v.boolean(),
        dateJoined: v.string(), // ISO date string
      }),
    ),
    totalCount: v.number(),
  }),
});

export type AdminFansParams = v.InferOutput<(typeof adminFansRpcContract)["paramsSchema"]>;
export type AdminFansResult = v.InferOutput<(typeof adminFansRpcContract)["resultSchema"]>;
export type AdminFan = v.InferOutput<(typeof adminFansRpcContract)["resultSchema"]>["fans"][0];
